import { combineReducers, createStore } from "redux";

import adminReducer from "./reducers/adminReducer";
import lastMaterialUpdatedReducer from "./reducers/lastMaterialUpdatedReducer";
import materialReducer from "./reducers/materialReducer";
import serviceReducer from "./reducers/serviceReducer";
import lasServiceReducer from "./reducers/lasServiceReducer";
import lasMaterialReducer from "./reducers/lasMaterialReducer";

const store = createStore(
  combineReducers({
    admin: adminReducer,
    material: materialReducer,
    service: serviceReducer,
    lasService: lasServiceReducer,
    lastMaterialUpdated: lastMaterialUpdatedReducer,
    lasMaterial: lasMaterialReducer,
  })
);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
export type Action = { type: string; payload: any };

export default store;
